<template>
  <div class="accessdenied-page container">

    <div class="columns">
      <div class="column is-6 is-offset-3">
        <h1 class="title has-text-centered">Acesso negado</h1>
        <p>Não foi possível realizar sua solicitação, por favor realize login novamente.</p>
        <p class="has-text-centered">
          <router-link to="/logout" class="button is-primary">Efetuar Login</router-link>
        </p>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'AccessDeniedPage'
}
</script>

<style lang="scss">
.accessdenied-page {
  margin-top: 100px
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AccessDeniedPage.vue